module.exports = __webpack_public_path__ + "components/Modals/Settings/Panels/AddComposition/folder.png?d7ab03f7";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/Settings/Panels/AddComposition/folder.png
// module id = 2376
// module chunks = 0